import { render, staticRenderFns } from "./allCategoriesSwipper.vue?vue&type=template&id=a6e4dfaa&"
import script from "./allCategoriesSwipper.vue?vue&type=script&lang=js&"
export * from "./allCategoriesSwipper.vue?vue&type=script&lang=js&"
import style0 from "./allCategoriesSwipper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports